module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-equipment-location":"Standort","not-recorded-yet":"Noch nicht erfasst","not-recorded":"nicht erfasst"},"fr":{"not-recorded":"pas saisi","not-recorded-yet":"Pas encore saisi","title-equipment-location":"Emplacement"},"it":{"not-recorded":"non registrato","not-recorded-yet":"Non ancora registrato","title-equipment-location":"Luogo/posizione"}}')
  delete Component.options._Ctor
}
